import styled from 'styled-components'
import {
  DescriptionOutlined as DescriptionOutlinedIcon,
} from "@material-ui/icons";

export const Container = styled.div`
	margin: 1rem 0;
`

export const StyledDescriptionOutlinedIcon = styled(DescriptionOutlinedIcon)`
	color: #fff;
`

export const ErrorMessage = styled.div`
  color: #F44336;
`